// BrandMark — assinatura "Brand Universe · admin" com a Canela do Maestro.
// Regra Maestro: canto reto, sem sombra, fonte Canela 400.

export function BrandMark({ muted = false }: { muted?: boolean }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: 'var(--space-2)',
        fontFamily: 'var(--font-display)',
        fontWeight: 400,
        fontSize: 22,
        lineHeight: 1,
        color: 'var(--ink)',
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 10,
          height: 10,
          background: 'var(--accent)',
          display: 'inline-block',
          transform: 'translateY(-1px)',
        }}
      />
      Brand Universe
      {!muted && (
        <em
          style={{
            fontStyle: 'italic',
            color: 'var(--ink-muted)',
            fontSize: 16,
            marginLeft: 2,
          }}
        >
          admin
        </em>
      )}
    </span>
  );
}
